/** Shared touch-friendly height for Management detail toolbar controls (WCAG 2.5.5 practical target). */
export const MANAGEMENT_TOOLBAR_CONTROL_HEIGHT_PX = 44;

/** Desktop floor-plan SVG height on location detail. */
export const MANAGEMENT_FLOOR_PLAN_SVG_HEIGHT_DESKTOP = 360;

/** Shorter floor-plan SVG on small viewports so charts stay reachable. */
export const MANAGEMENT_FLOOR_PLAN_SVG_HEIGHT_MOBILE = 240;
